const mockData = [
  {
    id: 1,
    title: 'Fresh Code',
    description:
      "Put it in MainActivity.java Use this in gradle: implementation 'com.github.satyan:sugar:1.4'",
    tag: 'Sugar DB',
    owner: 'Code Yard',
    score: '1200'
  },
  {
    id: 2,
    title: 'DoubleTextViewAdapter',
    description:
      "Use this to get 2 TextViews in a ListView.. You need to create DataModel.java and also the layout file'",
    tag: 'AndroidB',
    owner: 'Code Yard',
    score: '220'
  },
  {
    id: 3,
    title: 'A very complex python scripte',
    description: 'NOT RECOMMENDED FOR BEGINNERS',
    tag: 'pythonB',
    owner: 'Code Yard',
    score: '78'
  }
];

export default mockData;
